import axios from "axios";
import { autoLoginWithExpiredRefreshToken, RefreshToken } from "./AccessToken";
import { fetchOrgCodeAndValidate } from "./indexedDBHelper";
import { invalidAccessLogout } from "../../components/Utils/InvalidAccessLogout";
import { isAlive } from "../../components/Utils/SessionManagement";

// Endpoints where headers should not be added
const excludedEndpointsForAppModeandOrgCode = [
  "/validate_license",
  "/validate_organisation",
  "/all-test-panels",
  "/forgot_password",
  "/password_change_approval",
  "/verify_patient_mobile_no",
  "/register_patient_mobile_no",
  "/register_patient",
  "/get_facility_brand_configuration",
  "/patient_voice_assessment",
  "/book_patient_appointment",
  "/ai_services/",
  /** Website iframe integration — uses dedicated axios instance; exclude if routed through default axios */
  "organization_validation",
  "get_organization_info",
  "patient_guest_registration",
  "send_mobile_otp",
  "verify_mobile_otp",
  "refresh_access_token",
];

axios.interceptors.request.use(
  (config) => {
    // console.log("Before Interceptor:", { ...config.headers });
    // Ensure headers exist
    if (!config.headers) {
      config.headers = {};
    }

    // Only add custom headers if the request is NOT for an excluded endpoint
    if (
      !excludedEndpointsForAppModeandOrgCode.some((endpoint) =>
        config.url.includes(endpoint)
      )
    ) {
      config.headers["APP-MODE"] = sessionStorage.getItem("APP_MODE") || "";
      config.headers["ORG-CODE"] = sessionStorage.getItem("ORG_CODE") || "";
      config.headers["USER-ACCESS-KEY"] =
        sessionStorage.getItem("USER_ACCESS_KEY") || "";
      config.headers["USERNAME"] = sessionStorage.getItem("userName") || "";
    }

    // console.log("After Interceptor:", { ...config.headers });

    return config;
  },
  (error) => Promise.reject(error)
);

const excludedEndpointsForSessionManagement = [
  //Excluding endpoints
];
axios.interceptors.request.use(
  (config) => {
    if (!config.headers) {
      config.headers = {};
    }
    if (
      !excludedEndpointsForSessionManagement.some((endpoint) =>
        config.url.includes(endpoint)
      )
    ) {
      isAlive();
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// axios.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // If the error is due to a 401 status code and it's not a token refresh request
//     if (error.response.status === 401 && !originalRequest._retry) {
//       if (!sessionStorage.getItem("refreshToken")) {
//         return;
//       }
//       originalRequest._retry = true;

//       // logic for refreshing the tokens
//       const refreshed = await RefreshToken(
//         sessionStorage.getItem("refreshToken")
//       );

//       if (refreshed) {
//         // Retry the original request with the new access token
//         originalRequest.headers[
//           "Authorization"
//         ] = `Bearer ${sessionStorage.getItem("accessToken")}`;
//         return axios(originalRequest);
//       } else {
//         // Handle the case where refreshing the token fails
//         // For example, redirect to the login page or show an error message
//         console.log("Token refresh failed");
//       }
//     }

//     return Promise.reject(error);
//   }
// );
//---------------------------------------------
// let isRefreshing = false;
// let refreshSubscribers = [];

// // Notify all queued requests once token is refreshed
// const onRefreshed = (newToken) => {
//   refreshSubscribers.forEach((callback) => callback(newToken));
//   refreshSubscribers = [];
// };

// // Queue pending requests during token refresh
// const subscribeTokenRefresh = (callback) => {
//   refreshSubscribers.push(callback);
// };

// // Axios interceptor
// axios.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // Proceed only for 401 errors and only once per request
//     if (error.response?.status === 401 && !originalRequest._retry) {
//       const refreshToken = sessionStorage.getItem("refreshToken");

//       if (!refreshToken) {
//         console.warn("No refresh token found");
//         return Promise.reject(error);
//       }

//       originalRequest._retry = true;

//       try {
//         // First try regular refresh API
//         const refreshed = await RefreshToken(refreshToken);

//         if (refreshed) {
//           const newAccessToken = sessionStorage.getItem("accessToken");
//           originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
//           return axios(originalRequest);
//         } else {
//           // If already refreshing, queue this request
//           if (isRefreshing) {
//             return new Promise((resolve) => {
//               subscribeTokenRefresh((newToken) => {
//                 originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
//                 resolve(axios(originalRequest));
//               });
//             });
//           }

//           isRefreshing = true;

//           // Try auto login with expired refresh token
//           const autoLoggedIn = await autoLoginWithExpiredRefreshToken(
//             refreshToken
//           );
//           // const newAccessToken = sessionStorage.getItem("accessToken");
//           sessionStorage.setItem("accessToken", autoLoggedIn.data.access);
//           sessionStorage.setItem("refreshToken", autoLoggedIn.data.refresh);

//           if (autoLoggedIn.status === "Success" && autoLoggedIn.data.access) {
//             onRefreshed(autoLoggedIn.data.access); // Notify all queued requests
//             isRefreshing = false;

//             originalRequest.headers[
//               "Authorization"
//             ] = `Bearer ${autoLoggedIn.data.access}`;
//             return axios(originalRequest);
//           } else {
//             isRefreshing = false;
//             console.error("Auto-login failed after refresh token expired");
//             return Promise.reject(error);
//           }
//           // alert("to auto login");
//         }
//       } catch (err) {
//         isRefreshing = false;
//         console.error("Unexpected error in token handling", err);
//         return Promise.reject(err);
//       }
//     }

//     // For non-401 errors or retried requests, just pass the error
//     return Promise.reject(error);
//   }
// );
//=========================================
let isRefreshing = false;
let refreshSubscribers = [];

// Notify all queued requests once token is refreshed
const onRefreshed = (newToken) => {
  refreshSubscribers.forEach(({ resolve }) => resolve(newToken));
  refreshSubscribers = [];
};

/**
 * Release the queue when the refresh FAILED.
 *
 * Without this, a refresh that never succeeds leaves every queued request as a
 * promise nobody ever settles: the caller waits forever, and App.js's global
 * loader — which counts in-flight requests — never gets its decrement, so the
 * full-screen spinner stays up for the rest of the session. A hung
 * login/refresh/ took the whole app down this way.
 */
const onRefreshFailed = (reason) => {
  refreshSubscribers.forEach(({ reject }) => reject(reason));
  refreshSubscribers = [];
};

// Queue pending requests during token refresh
const subscribeTokenRefresh = (resolve, reject) => {
  refreshSubscribers.push({ resolve, reject });
};

// A refresh that never answers is what strands the queue above, so give it a
// deadline of its own regardless of any global axios timeout.
const REFRESH_TIMEOUT_MS = 20000;

const withRefreshTimeout = (promise) =>
  Promise.race([
    promise,
    new Promise((_, reject) =>
      setTimeout(
        () => reject(new Error("Token refresh timed out")),
        REFRESH_TIMEOUT_MS,
      ),
    ),
  ]);

// The synthesized errors below replace a real axios error, and anything reading
// `error.config` downstream (App.js's loader counter, retry logic) goes blind if
// that context is dropped. Carry it over.
const withConfig = (error, config) => Object.assign(error, { config });

const webIntegrationUrlMarkers = [
  "organization_validation",
  "get_organization_info",
  "patient_guest_registration",
  "send_mobile_otp",
  "verify_mobile_otp",
  "refresh_access_token",
];

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      originalRequest?.url &&
      webIntegrationUrlMarkers.some((m) => originalRequest.url.includes(m))
    ) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry && error.response?.data?.code !== "user_inactive") {
      const refreshToken = sessionStorage.getItem("refreshToken");

      if (!refreshToken) {
        console.warn("No refresh token found");
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      // If already refreshing, queue the request
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          subscribeTokenRefresh(
            (newToken) => {
              originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
              resolve(axios(originalRequest));
            },
            // Refresh failed → fail this request too, rather than hanging. The
            // original error carries the config the loader counter needs.
            () => reject(error),
          );
        });
      }

      isRefreshing = true;

      try {
        // Only the first request attempts refresh
        const refreshed = await withRefreshTimeout(RefreshToken(refreshToken));

        if (refreshed) {
          const newAccessToken = sessionStorage.getItem("accessToken");

          onRefreshed(newAccessToken); // Notify queued requests
          isRefreshing = false;

          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return axios(originalRequest);
        } else {
          // Try auto login with expired refresh token
          const autoLoggedIn = await autoLoginWithExpiredRefreshToken(
            refreshToken
          );

          sessionStorage.setItem("accessToken", autoLoggedIn.data.access);
          sessionStorage.setItem("refreshToken", autoLoggedIn.data.refresh);

          if (autoLoggedIn.status === "Success" && autoLoggedIn.data.access) {
            onRefreshed(autoLoggedIn.data.access);
            isRefreshing = false;

            originalRequest.headers[
              "Authorization"
            ] = `Bearer ${autoLoggedIn.data.access}`;
            return axios(originalRequest);
          } else {
            isRefreshing = false;
            onRefreshFailed(error);
            console.error("Auto-login failed after refresh token expired");
            return Promise.reject(error);
          }
        }
      } catch (err) {
        isRefreshing = false;
        // Every request queued behind this refresh has to be released, or it
        // waits forever — see onRefreshFailed.
        onRefreshFailed(err);
        console.error("Unexpected error in token handling", err);
        return Promise.reject(err);
      }
    } else if (error.response?.status === 401 && !originalRequest._retry && error.response?.data?.code === "user_inactive") {
      invalidAccessLogout();
      return Promise.reject(withConfig(new Error("User is inactive"), originalRequest));
    }

    return Promise.reject(error);
  }
);

const excludedEndpointsForMultipleMachinesLogin = [
  "/register_patient",
  "/register_patient_mobile_no",
  "/verify_patient_mobile_no",
  "/ai_services/",
  "organization_validation",
  "get_organization_info",
  "patient_guest_registration",
  "send_mobile_otp",
  "verify_mobile_otp",
  "refresh_access_token",
];

axios.interceptors.response.use(
  (response) => {
    const { config, data } = response;

    // Check if endpoint is excluded
    const isExcluded = excludedEndpointsForMultipleMachinesLogin.some(
      (endpoint) => config.url.includes(endpoint)
    );
    // If not excluded, and is_valid is false, then force logout
    if (!isExcluded && data && data.is_valid === false) {
      invalidAccessLogout({ skipLogoutApi: true });
      return Promise.reject(withConfig(new Error("Session invalidated"), config));
    }

    return response;
  },
  (error) => {
    // Still reject the error so the other interceptor or catch blocks handle it
    return Promise.reject(error);
  }
);

export default axios;

// import axios from 'axios';
// import { RefreshToken } from './AccessToken';

// // A flag to indicate whether a token refresh is in progress
// let isRefreshing = false;
// // A queue to hold all requests while a token refresh is in progress
// let failedQueue = [];

// const processQueue = (error, token = null) => {
//   failedQueue.forEach((promise) => {
//     if (token) {
//       promise.resolve(axios(promise.request));
//     } else {
//       promise.reject(error);
//     }
//   });

//   failedQueue = [];
// };

// axios.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     if (error.response.status === 401 && !originalRequest._retry) {
//       // Mark the request as retried to prevent loops
//       originalRequest._retry = true;

//       // If a token refresh is already in progress, queue the request
//       if (isRefreshing) {
//         return new Promise((resolve, reject) => {
//           failedQueue.push({ request: originalRequest, resolve, reject });
//         });
//       }

//       // Otherwise, start a new token refresh process
//       isRefreshing = true;

//       try {
//         const refreshed = await RefreshToken(sessionStorage.getItem('refreshToken'));

//         if (refreshed) {
//           // Retry the original request with the new access token
//           originalRequest.headers['Authorization'] = `Bearer ${sessionStorage.getItem('accessToken')}`;
//           processQueue(null, sessionStorage.getItem('accessToken'));
//           return axios(originalRequest);
//         } else {
//           // If refreshing the token fails, reject the queue
//           processQueue(new Error('Token refresh failed'), null);
//           return Promise.reject(error);
//         }
//       } catch (err) {
//         processQueue(err, null);
//         return Promise.reject(err);
//       } finally {
//         isRefreshing = false;
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default axios;
